import React from "react";
import styled, {css} from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {useGlobal} from "reactn";
import {rgba} from "polished";
import {ButtonText, PrimaryButton} from "Buttons";
import {GetTextColor} from "Helpers/ColorHelper";
import {LazyComponent} from "../../framework/lazy/LazyComponent";
import {FocalPointImage} from "../../framework/lazy/FocalPointImage";
import {getResponsiveImage} from "Helpers/ImageHelper";
import {useFocalPoint} from "../../framework/hooks/useFocalPoint";

export const QuotationBlock = ({
                                 Text,
                                 Icon,
                                 IconAlt,
                                 ButtonText: BtnText,
                                 ButtonLink,
                                 ResponsiveImage,
                                 OverlayColor,
                               }) => {
  const [theme] = useGlobal("theme");

  let Image = getResponsiveImage(ResponsiveImage);
  let alt = ResponsiveImage.Alt;
  const addImageAttributes = alt && alt.length > 0 ? {role: "img", "aria-label": alt} : {"aria-hidden": "true"};
  const addIconAttributes = IconAlt && IconAlt.length > 0 ? {role: "img", "aria-label": IconAlt} : {"aria-hidden": "true"};

  const {isCropped, coordinates} = useFocalPoint(Image);
  let overlayColor = OverlayColor != "" ? `#${OverlayColor}` : theme.colors.primary;
  const {textColor, hoverColor} = GetTextColor(OverlayColor);
  const overlay = `linear-gradient(to right, ${overlayColor} 52%, ${rgba(
    `${overlayColor}`,
    0.4
  )})`;

  return (
    <LazyComponent
      height="16rem"
      overlay={overlay}
      source={Image}
      overlayColor={OverlayColor}
    >
      <QuotationWrapper
        {...{isCropped}}
        {...{coordinates}}
        bgImage={Image}
        overlay={overlay}
        {...addImageAttributes}
      >
        <QuotationOuterWrapper>
          <Content>
            <QuoteWrapper>
              {Text && (
                <Quote
                  color={textColor}
                  dangerouslySetInnerHTML={{
                    __html: Text,
                  }}
                ></Quote>
              )}
            </QuoteWrapper>
            {ButtonLink.length > 0 && BtnText.length > 0 && (
              <QuoteButtonWrapper>
                <PrimaryButton
                  className={textColor === "#fff" ? 'fff' : ''}
                  inverted
                  hoverColor={textColor}
                  borderColor={textColor}
                  background={theme.colors.none}
                  wide
                  textColor={textColor}
                  textColorHover={hoverColor}
                  widthsmall="100%"
                  href={ButtonLink}
                >
                  <ButtonText heading={`quote ${BtnText}`}>{BtnText}</ButtonText>
                </PrimaryButton>
              </QuoteButtonWrapper>
            )}
          </Content>
          {Icon !== undefined && <QuoteIconWrapper bgImage={Icon} {...addIconAttributes} />}
        </QuotationOuterWrapper>
      </QuotationWrapper>
    </LazyComponent>
  );
};

const QuotationWrapper = styled(FocalPointImage)`
    background: ${({bgImage, overlay, coordinates}) =>
            overlay
                    ? (coordinates && bgImage)
                            ? `${overlay}, url(${bgImage}) ${coordinates.x}% ${coordinates.y}%`
                            : `${overlay} ${bgImage ? `, url(${bgImage})` : ''}`
                    : bgImage ? `url(${bgImage})` : ''};
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    min-height: 16rem;
    padding: 6rem 1rem;

    ${media.lessThan(breakpoints.mobile)`
		padding: 4rem 1rem;
    `}
`;

const Content = styled.div`
    width: 100%;
`;
const QuotationOuterWrapper = styled.div`
    max-width: 866px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    ${media.lessThan(breakpoints.mobile)`
		flex-direction: column-reverse;
    `}
`;

const QuoteButtonWrapper = styled.div`
    display: flex;

    ${media.lessThan(breakpoints.mobile)`
        margin: 0rem auto 0 auto;
        max-width: 300px;
    `}
`;

const QuoteWrapper = styled.div`
    display: flex;
    align-items: end;

    ${media.lessThan(breakpoints.mobile)`
        flex-direction: column-reverse;
        align-items: center;
    `}
`;
const Quote = styled.p`
    font-family: ${({theme}) => theme.font};
    font-size: 32px;
    font-weight: bold;
    line-height: 1.19;
    max-width: 715px;
    margin: 0 3rem 0 0;

    p {
        color: ${({theme, color}) => (color ? color : theme.colors.white)};
    }

    ${media.lessThan(breakpoints.mobile)`
        font-size: 20px;
        margin: 1rem 0 0 0;
    `}
`;

const QuoteIconWrapper = styled.div`
    max-height: 13rem;
    height: 13rem;
    max-width: 13rem;
    min-width: 13rem;
    ${({bgImage}) =>
            bgImage &&
            css`
                background: ${({bgImage}) => bgImage};
                background-size: contain;
                background-repeat: no-repeat;
                background-position: 50% center;
            `}
    ${media.lessThan(breakpoints.mobile)`
	max-width: 8rem;
	max-height: 8rem;
`}
`;
